export const TOOLTIP_SHOW_TIME = 2000;
export const PRICE_FONT_SIZE_IN_REM = '1rem';
